export default {
    methods: {
        async validateForm(validator) {
            const validate = await validator.validate();

            if (!validate) {
                const elem = $('input:text.parsley-error');
                if (elem.length) {
                    elem[0].focus();
                }

                let item = validator.errors.items[0];

                this.errors.add({
                    field: item.field,
                    msg: item.msg,
                });
            }

            return validate;
        },

        clearForm(validator) {
            validator.errors.clear();
        },

        validateField(value, field, fieldName = null) {
            if (_.isNull(value) || value == 0 || String(value).trim() == '') {
                this.errors.add({
                    field: field,
                    msg: `The ${
                        fieldName ? fieldName : field
                    } field is required`,
                });

                this.hasValidationError = true;

                return false;
            }

            return true;
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/handle-validator-ui.js